import { exists } from '@/helpers'

enum RouterPath {
  Movies = 'movies',
  Epg = 'epg',
  Tv = 'tv',
  Catchups = 'catchups',
  Shows = 'shows',
  Events = 'events',
  Search = 'search',
  Default = 'home',
}

const getRoute = (pathname?: string) => {
  if (pathname == null) return ''
  if (pathname.includes(RouterPath.Movies)) return RouterPath.Movies
  if (pathname.includes(RouterPath.Epg)) return RouterPath.Epg
  if (pathname.includes(RouterPath.Tv)) return RouterPath.Tv
  if (pathname.includes(RouterPath.Catchups)) return RouterPath.Catchups
  if (pathname.includes(RouterPath.Shows)) return RouterPath.Shows
  if (pathname.includes(RouterPath.Events)) return RouterPath.Events
  if (pathname.includes(RouterPath.Search)) return RouterPath.Search
  return RouterPath.Default
}

export const formatRouterLocation = ({
  pathname,
  categoryName,
}: {
  pathname?: string
  categoryName?: string
}): string => {
  const route = getRoute(pathname)
  if (exists(categoryName) && exists(pathname))
    return `${route}/${categoryName}`
  return route
}
